import { combineRules } from 'fela';

import type { TRuleWithTheme } from '@/styles/theme';

// The sidebar container has 1.5rem horizontal padding; pull the item back out
// to an ~8px gutter (matching the Figma) via negative margins, like UserMenu.
export const item: TRuleWithTheme = ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(8),
    height: '48px',
    marginRight: '-1rem',
    marginLeft: '-1rem',
    padding: `${theme.spacing(12)} ${theme.spacing(8)} ${theme.spacing(12)} ${theme.spacing(12)}`,
    borderRadius: theme.spacing(8),
    ...theme.typography.ParagraphNormalMedium,
    color: theme.colors.foregroundsPrimary,
    textDecoration: 'none',
    transition: 'background-color 0.15s ease',

    ':hover': {
        backgroundColor: theme.colors.listItemHoverBg,
        color: theme.colors.foregroundsPrimary,
    },
    '&.active': {
        backgroundColor: theme.colors.listItemSelectedBg,
        color: theme.colors.accentPrimary,
    },
    '&.active:hover': {
        backgroundColor: theme.colors.listItemSelectedBg,
        color: theme.colors.accentPrimary,
    },
});

export const button = combineRules(item, (() => ({
    width: 'calc(100% + 2rem)',
    border: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    textAlign: 'left',
})) as TRuleWithTheme);

export const icon: TRuleWithTheme = () => ({
    flexShrink: 0,
});

export const label: TRuleWithTheme = () => ({
    flex: 1,
    minWidth: 0,
    wordBreak: 'break-word',
});
